import { config } from "@config";

export class FiatDepositConfig {
	static readonly outletName: string = "modal";
	static readonly entryPathName: string = "fiat-deposit";
	static readonly filterAssetsByFields: string[] = ["name", "symbol"];
	static readonly assembleHelpdeskLink = (langPart: string): string =>
		`${config.helpcenterUrl}hc/${langPart}/articles/${config.externalPaths["deposit"]["tooltip"]}`;
	static readonly connectToBankRedirectDelayMilliseconds = 3000;
	static readonly defaultNextPageToLoad = 2;
	static readonly defaultPageToLoad = 1;
	static readonly defaultPageSize = 50;
	static readonly prodAppUrl = "https://web.bitpanda.com/";
}
